// extracted by mini-css-extract-plugin
export default {"pageContent":"aboutUs_pageContent__d2lXm"};